import { Form, Formik, getIn } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { HtmlContent } from '../../global-component-styles';
import GlobalStyles from '../../global-styles';
import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField,
  Typography
} from '../../utils/material-ui-core';

interface ConfirmProps {
  title: string;
  content: string;
  yesText: string;
  noText: string;
  open: boolean;
  showReason: boolean;
  required: boolean;
  reasonLabel: string;
  callbackOnConfirm: (confirmWithReasonOutput: ConfirmWithReasonOutput) => void;
}

const formDefaultValue = {
  val: "",
};

const formDefaultTouchValue = {
  val: false,
};

let formValidationSchema = Yup.object().shape({});

const ConfirmWithReason = ({ title, content, yesText, noText, open, showReason, required, reasonLabel, callbackOnConfirm }: ConfirmProps) => {
  const pageStyles = LocalPageStyles();
  const globalStyles = GlobalStyles();

  const formReference = useRef(null) as any;
  const [initialFormValues, setInitialFormValues] = useState<{ val: any }>(formDefaultValue);

  const confirm = () => {
    const confirmWithReasonOutput: ConfirmWithReasonOutput = {
      confirm: true,
      reason: formReference.current.values.val,
    };
    callbackOnConfirm(confirmWithReasonOutput);
  };

  const cancel = () => {
    const confirmWithReasonOutput: ConfirmWithReasonOutput = {
      confirm: false,
      reason: "",
    };
    callbackOnConfirm(confirmWithReasonOutput);
  };

  useEffect(() => {
    if (open) {
      formValidationSchema = Yup.object().shape({});
      if (showReason && required) {
        formValidationSchema = Yup.object().shape({
          val: Yup.string()
            .trim()
            .required(reasonLabel + " is required."),
        });
      }
      setInitialFormValues({ val: "" });
    }
  }, [open, reasonLabel, required, showReason, title]);

  return (
    <Dialog className={globalStyles.dialogContainer} open={open} maxWidth={"sm"} fullWidth={true}>
      <DialogTitle className={globalStyles.dialogTitleContainer}>
        <Typography variant="body1" component="span">
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText className={pageStyles.contentText} component="div">
          <HtmlContent dangerouslySetInnerHTML={{ __html: content }}></HtmlContent>

          <Formik
            innerRef={formReference}
            initialValues={initialFormValues}
            validationSchema={formValidationSchema}
            validateOnMount={true}
            initialTouched={formDefaultTouchValue}
            validateOnBlur={true}
            validateOnChange={true}
            onSubmit={(values: any) => {
              confirm();
            }}
          >
            {({ values, errors, handleChange, setFieldValue, touched, handleBlur, isSubmitting, validateForm }) => <Form>{showReason ? <TextField autoFocus multiline={true} margin="dense" id="val" name="val" value={values.val} label={reasonLabel} fullWidth onChange={handleChange} onBlur={handleBlur} error={Boolean(getIn(touched, "val") && getIn(errors, "val"))} helperText={getIn(touched, "val") && getIn(errors, "val")} /> : null}</Form>}
          </Formik>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => formReference.current.handleSubmit()} color="secondary" variant="contained" autoFocus>
          {yesText}
        </Button>
        <Button onClick={() => cancel()} className={globalStyles.buttonDefault} autoFocus>
          <u>{noText}</u>
        </Button>
      </DialogActions>
    </Dialog>
  );
};
const LocalPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    contentText: {
      whiteSpace: "pre-wrap",
    },
    deleteButton: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText,
    },
  })
);

export default ConfirmWithReason;
